<template>
  <a
    :href="path"
    class="item">
    <restaurant-navigation-category-title-layout
      :title="title"
      :category-icon="categoryIcon"
    >
      <icon-angle-bracket
        slot="action"
        class="item__arrow"/>
    </restaurant-navigation-category-title-layout>
  </a>
</template>

<script>
import { categoryLinkProps } from '@/mikan/_shared/types/vueTypes/restaurantNavigation';
import { getCategoryIconNameFromTitle } from '@/mikan/_shared/lib/componentHelpers/formatRestaurantNavigationItems';
import RestaurantNavigationCategoryTitleLayout from '@/mikan/_shared/components/molecules/RestaurantNavigationCategoryTitleLayout.vue';
import IconAngleBracket from '@/mikan/_shared/components/atoms/icons/IconAngleBracket.vue';

export default {
  components: {
    RestaurantNavigationCategoryTitleLayout,
    IconAngleBracket,
  },
  props: {
    ...categoryLinkProps,
  },
  computed: {
    categoryIcon() {
      return getCategoryIconNameFromTitle(this.title);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/mikan/_shared/base/constants';

.item {
  $root: &;

  display: block;

  &:hover {
    color: $color-text-link;
  }

  &__arrow {
    height: 100%;
    flex: 0 0 auto;
    color: $color-navy-20;
    transition: color $transition-base;

    @at-root #{$root}:hover & {
      color: $color-text-link;
    }
  }
}
</style>
